<template>
  <div id="app">
    <Sidepop />
    <StaticPopup />
    <router-view />
  </div>
</template>

<script>
import Sidepop from "@/components/Sidepop.vue";
import StaticPopup from "@/components/StaticPopup.vue";
export default {
  name: "App",
  components: {
    Sidepop,
    StaticPopup,
  },
  metaInfo() {
    return {
      ssrAppId: "sela",
      ...this.seo({
        title: "Cloud Better.",
        image: "https://sfo2.digitaloceanspaces.com/bagel/sela/og.jpg",
        //description: "Get the most out of your cloud(s) with tailored managed services & skilling, unbiased consulting, and empowering 360 support.",
        twitterHandle: "@selahq",
      }),
      titleTemplate: "%s | Sela.",
    };
  },
};
</script>

<style src="./bagelLinkLayout.css"></style><!-- used in Logos.vue-->
<style src="./main.css"></style>
<style src="./nati.css"></style>
